import { getAnalyticTags } from "core/lib/analytics-methods";
import dateTimeWrapper from "core/lib/date-time-wrapper";
import { CurrentDateTime, PopupInfo, Programme } from "core/types";

const highLightState = {
  past: "past-item",
  current: "current-item",
  last: "past-item-show",
  none: ""
}

type ListItemProps = {
  programme: Programme;
  currentDateTime: CurrentDateTime;
  isLastProgram: boolean;
  setShowPopup: (value: boolean) => void;
  setPopupInfo: (value: PopupInfo | undefined) => void;
}

const ListItemComponent = (props: ListItemProps) => {
  const { programme, currentDateTime, isLastProgram, setShowPopup, setPopupInfo } = props;

  const start = dateTimeWrapper(programme.startTime);
  const end = dateTimeWrapper(programme.endTime);
  const current = currentDateTime;

  const isCurrentDate = current.date === start.date;

  const getHighLightState = () => {
    if (isCurrentDate) {
      if (isLastProgram) {
        return highLightState.last;
      }

      if (current.time >= end.time && current.date) {
        return highLightState.past;
      }

      if (
        current.time >= start.time &&
        current.time < end.time
      ) {
        return highLightState.current;
      }

      if (current.time < start.time) {
        return highLightState.none;
      }
    }

    if (start.datetime < current.datetime) {
      return highLightState.past;
    }

    return highLightState.none;
  }

  const state = getHighLightState();

  const analytics = getAnalyticTags({
    component_name: "tv_guide_channel_show_clicks",
    component_type: "show_clicks",
    show_name: programme.title,
    show_runtime: `${programme.startTime}_${programme.endTime}`
  });

  const click = () => {
    setShowPopup(true);
    setPopupInfo({
      id: props.programme.uniqueEventID,
      current: state === highLightState.current,
      hide: state === highLightState.past
    });
  }

  return (
    <div
      className={`schedule-item programme-item ${state}`}
      {...analytics}
      onClick={click}>
      <span className="programme-time">{start.time}</span>
      <span className="programme-title">{programme.title}</span>
    </div>
  );
}

export default ListItemComponent;
